<script lang="ts">
	import { Pagination as PaginationPrimitive } from "bits-ui";
	import ChevronRight from "svelte-radix/ChevronRight.svelte";
	import { Button } from "$lib/components/ui/button/index.js";
	import { cn } from "$lib/utils.js";
	import { t } from 'svelte-i18n'

	type $$Props = PaginationPrimitive.NextButtonProps;
	type $$Events = PaginationPrimitive.NextButtonEvents;

	let className: $$Props["class"] = undefined;
	export { className as class };

	export let hideText: boolean = false
</script>

<PaginationPrimitive.NextButton asChild let:builder>
	<Button
		variant="ghost"
		size="sm"
		class={cn("gap-1 pr-2.5", className)}
		builders={[builder]}
		on:click
		{...$$restProps}
	>
		<slot>
			<span class="text-xs">{$t('global.messages.next')}</span>
			<ChevronRight class="h-3.5 w-3.5" />
		</slot>
	</Button>
</PaginationPrimitive.NextButton>
